export const REQUIRED_MEASUREMENTS = [
  'temperature',
  'humidity',
  'par',
  'carbon_dioxide',
  'wind_speed',
  'vapour_pressure_deficit',
  'daily_light_integral',
  'soil_temperature',
  'soil_moisture',
  'soil_ph',
  'soil_ec',
  'soil_nitrogen',
  'soil_phosphorus',
  'soil_potassium'
]
